import React from 'react';

interface SectionProps {
    additionalClasses?: string;
}
const Section: React.FC<SectionProps> = (props) => {
    const { children, additionalClasses } = props;
    return <section className={`section ${additionalClasses}`}>{children}</section>;
};

export default Section;
